/**
 * All Components Imports
 */
import { HttpClientModule } from '@angular/common/http';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Custom Validator
import { AxisValidatorModule } from './customValidators/axis-validator.module';
import { AxisOktaModule } from './okta/axis-okta.module';
// Icon
import { IconModule } from './icon/icon.module';
import { AccordionModule } from './accordion/accordion.module';
// Alert
import { AlertModule } from './alert/alert.module';
// AQI
import { AQIModule } from './aqi/aqi.module';
// Button
import { ButtonsModule } from './button/button.module';
// Captcha
import { AxisCaptchaModule } from './captcha/captcha.module';
// Card
import { CardModule } from './card/card.module';
// Carousel
import { CarouselModule } from './carousel/carousel.module';
// Checkbox
import { CheckboxModule } from './checkBox/checkbox.module';
// Chip-list
import { ChipListModule } from './chip-list/chip-list.module';
// Common Errors
import { CommonErrorsModule } from './common-errors/common-errors.module';
// Countdown
import { CountModule } from './countDown/countdown.module';
// Columns
import { ColumnsModule } from './columns/columns.module';
// Datepicker
import { DatepickerModule } from './datepicker/datepicker.module';
// Calendar
import { CalendarModule } from './calendar/calendar.module';
// Dropdown
import { DropdownModule } from './dropdown/dropdown.module';
// Dual list
import { DualListModule } from './dualList/dualList.module';
// Editor
import { EditorModule } from './editor/editor.module';
// File Upload
import { FileUploadModule } from './file-upload/fileupload.module';
// Input
import { InputModule } from './input/input.module';
// Intro tour
import { IntroTourModule } from './intro-tour/intro-tour.module';
// List
import { ListModule } from './list/list.module';
// Spinner
import { LoadingModule } from './loading/loading.module';
// Media
import { MediaModule } from './media/media.module';
// Modal
import { ModalModule } from './modal/modal.module';
// Nav Bar
import { NavbarModule } from './navbar/navbar.module';
// Okta authentication
import { OktaAuthModule } from './okta-auth/okta-auth.module';
// Progress Bar
import { ProgressBarModule } from './progress-bar/progressbar.module';
// Radio Button
import { RadioButtonModule } from './radio-button/radio-button.module';
// Range date Picker
import { DateRangePickerModule } from './date-range-picker/date-range-picker.module';
// Scroll2tb
import { Scroll2tbModule } from './scroll2tb/scroll2tb.module';
// scrollContainer
import { ScrollContainerModule } from './scroll-container/scroll-container.module';
// styled list
import { StyledListModule } from './styled-list/styled-list.module';
// slider
import { SliderModule } from './slider/slider.module';
// Tab
import { TabsModule } from './tab/tab.module';
// Timepicker
import { TimepickerModule } from './timepicker/timepicker.module';
// Timer
import { TimerModule } from './timer/timer.module';
// Tooltip
import { TooltipModule } from './tooltip/tooltip.module';
// Truncate
import { TruncateModule } from './truncate/truncate.module';
// Utilities
import { UtilsModule } from './utilities/utils.module';
//Breadcrumb
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';

/**
 * Module to Export
 */
@NgModule({
  imports: [
    FormsModule,
    // BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AccordionModule,
    AlertModule,
    AQIModule,
    AxisOktaModule,
    ButtonsModule,
    CardModule,
    CheckboxModule,
    ChipListModule,
    CommonErrorsModule,
    CountModule,
    ColumnsModule,
    DropdownModule,
    CalendarModule,
    DatepickerModule,
    DualListModule,
    EditorModule,
    FileUploadModule,
    InputModule,
    IconModule,
    AxisValidatorModule,
    ListModule,
    MediaModule,
    ModalModule,
    NavbarModule,
    OktaAuthModule,
    ProgressBarModule,
    RadioButtonModule,
    DateRangePickerModule,
    TimepickerModule,
    Scroll2tbModule,
    ScrollContainerModule,
    StyledListModule,
    SliderModule,
    TabsModule,
    TooltipModule,
    TruncateModule,
    AxisCaptchaModule,
    UtilsModule,
    LoadingModule,
    IntroTourModule,
    BreadcrumbModule,
    TimerModule
  ],
  exports: [
    // Components
    AccordionModule,
    AlertModule,
    AQIModule,
    AxisOktaModule,
    ButtonsModule,
    CardModule,
    CarouselModule,
    CheckboxModule,
    ChipListModule,
    CommonErrorsModule,
    CountModule,
    ColumnsModule,
    DropdownModule,
    CalendarModule,
    DatepickerModule,
    DualListModule,
    EditorModule,
    FileUploadModule,
    InputModule,
    IconModule,
    AxisValidatorModule,
    ListModule,
    MediaModule,
    ModalModule,
    NavbarModule,
    OktaAuthModule,
    ProgressBarModule,
    RadioButtonModule,
    DateRangePickerModule,
    Scroll2tbModule,
    ScrollContainerModule,
    StyledListModule,
    SliderModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    TruncateModule,
    AxisCaptchaModule,
    UtilsModule,
    LoadingModule,
    IntroTourModule,
    BreadcrumbModule,
    TimerModule
  ]
})
export class AxisComponentsAllModule { }
